import api, { withLoading } from '@/api/api';

const resource = `v1/rpa`;
const LOADING_KEY = 'rda-rpa';

export default {
  getConsolidado(empresaId, params = {}) {
    const { competenciaIni, competenciaFim } = params;
    return withLoading(LOADING_KEY, () =>
      api.get(`v1/projetos/${empresaId}/justificativas/consolidado/li`, {
        params: { competenciaIni, competenciaFim, trabalho: 2 },
      }).then(res => res.data)
    );
  },

  disparar(empresaId, payload) {
    return withLoading(LOADING_KEY, () =>
      api.post(`${resource}/${empresaId}/preenchimento`, payload)
        .then(res => res.data)
    );
  },
};
